$(() => {
  function photoSorter() {
    $('.js-photo-sortable-item').each((i, item) => {
      $(item).find('.js-photo-position').val(i);
    });
  }
  photoSorter();

  // ソートの設定
  $('.js-photo-sortable').sortable({
    items: '.js-photo-sortable-item',
    handle: '.js-sort-handler',
    update: photoSorter,
  });

  // 追加ボタンの活性/非活性制御
  function enableAdditionalButton(container) {
    const elementCount = container.find('.js-destroyable-item:visible').length;
    const limit = container.data('limit');
    if (elementCount >= limit) {
      container.find('.js-photo-addition').attr('disabled', true).addClass('disabled');
    } else {
      container.find('.js-photo-addition').attr('disabled', false).removeClass('disabled');
    }
  }

  // 写真追加時の処理
  $('.js-photo-addition').on('ajax:success', e => {
    enableAdditionalButton($(e.currentTarget).closest('.js-photo-selected-container'));
    photoSorter();
  });

  // 写真選択時の処理
  $('.js-photo-selector-container').on('click', '.js-select-photo', e => {
    const $selectPhoto = $(e.currentTarget);
    const $target = $($selectPhoto.data('target'));
    $target.find('.js-photo-id').val($selectPhoto.data('id'));
    $target.find('.js-selected-photo img').attr('src', $selectPhoto.data('src')).show();
    $selectPhoto.closest('.js-select-photo-modal').modal('hide');
    return false;
  });

  // 写真設定解除時の処理
  $('.js-photo-selected-container').on('click', '.js-photo-unset', e => {
    const $photoUnset = $(e.currentTarget);
    const $destroyableItem = $photoUnset.closest('.js-destroyable-item');
    $destroyableItem.find('.js-destroy-input').val('1');
    $destroyableItem.hide('fast', () => {
      enableAdditionalButton($photoUnset.closest('.js-photo-selected-container'));
    });
    return false;
  });
});
